import store from '@/store';


export default function routerBeforeEnterFavorites(to, from, next) {
  const hideFavorites = store.getters['merchant/merchant'].features['hide-favorites'];

  if (hideFavorites) {
    let redirectRoute = {
      name: 'orderMenu',
      params: { merchantId: to.params.merchantId }
    };

    const { alternateLandingPage } = store.getters['merchant/merchant'].options;

    if (alternateLandingPage) {
      redirectRoute = { path: new URL(alternateLandingPage).pathname };
    }

    next(redirectRoute);
  }
  else {
    next();
  }
}
